export default __webpack_public_path__ + "static/media/Webinar_Ranganathan.c17567dc.jpg";